module.exports = __webpack_public_path__ + "public/SiteIcons/correct.svg?b1bc874c";